import React, { Component } from 'react';
import { connect } from 'react-redux';
import './BuildingsEdit.css';
import Tabbar from '../../../Components/Tabbar/Tabbar';
import { Link, Redirect } from 'react-router-dom';
import { edit, getOne } from '../../../Store/Actions/RestActions';
import { TimePicker } from '@progress/kendo-dateinputs-react-wrapper';

class BuildingEditPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			abbreviation: '',
			description: '',
			open: '',
			closed: '',
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleOpenChange = this.handleOpenChange.bind(this);
		this.handleClosedChange = this.handleClosedChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	componentDidMount() {
		const locationSteal = window.location.pathname.match(/\/buildings\/(.*)/);
		if (locationSteal.length > 1) {
			this.props.buildingFetch(locationSteal[1]);
		}
	}

	componentWillReceiveProps(newProps) {
		this.setState({ name: newProps.buildings.name, abbreviation: newProps.buildings.abbreviation, description: newProps.buildings.description, open: newProps.buildings.open, closed: newProps.buildings.closed, id: newProps.buildings.id });
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	handleOpenChange(event) {
		this.setState({ open: event.sender.value() });
	}
	handleClosedChange(event) {
		this.setState({ closed: event.sender.value() });
	}

	handleSubmit(event) {
		event.preventDefault();
		const locationSteal = window.location.pathname.match(/\/buildings\/(.*)/);
		if (locationSteal.length > 1) {
			this.props.buildingFetch(locationSteal[1]);
		}
		this.props.editBuilding({ name: this.state.name, abbreviation: this.state.abbreviation, description: this.state.description, id: this.state.id, open: this.state.open, closed: this.state.closed }, this.state.id);
	}

	render() {
		if (this.props.fireRedirect) {
			return (
				<Redirect to="/buildings" />
			);
		}
		// handling null date for the time picker
		let openTime = "";
		if (this.state.open) {
			openTime = new Date(this.state.open);
		}
		let closedTime = "";
		if (this.state.closed) {
			closedTime = new Date(this.state.closed);
		}
		return (
			<div className="container">
				<Tabbar setActiveTab="buildings" />
				<div className="contentBox tabbed-content-box addBuilding">
					<form onSubmit={this.handleSubmit}>
						<h3>Edit Building</h3>
						<Link className="addCancel" to="/buildings">X</Link>
						<div className="ResourceAddLeft">
							<div className="inputGroup">
								<label className="">Name:</label>
								<input
									className="addBldgInput"
									type="text"
									placeholder={this.state.name}
									name="name"
									value={this.state.name}
									onChange={this.handleInputChange}
								/>
							</div>
							<div className="inputGroup">
								<label className="">Abbreviation:</label>
								<input
									className="addBldgInput"
									type="text"
									placeholder={this.state.abbreviation}
									name="abbreviation"
									value={this.state.abbreviation}
									onChange={this.handleInputChange}
								/>
							</div>
							<div className="inputGroup">
								<label className="">Description:</label>
								<input
									className="addBldgInput"
									type="text"
									placeholder="Enter description here"
									name="description"
									value={this.state.description || ''}
									onChange={this.handleInputChange} />
							</div>
							<div className="timeInputGroup">
								<label className="timeInputLabel"> Open Time:</label>
								<TimePicker
									value={openTime}
									name="open"
									change={this.handleOpenChange}
								/>
							</div>
							<div className="timeInputGroup right">
								<label className="timeInputLabel"> Close Time:</label>
								<TimePicker
									value={closedTime}
									name="closed"
									change={this.handleClosedChange}
								/>
							</div>
						</div>
						<div className="formControls">
							<input className="addSubmit" type="submit" value="Edit Building" />
						</div>
					</form>
				</div>
			</div>
		);
	}
}
const mapStateToProps = state => ({
	buildings: state.buildings.data,
	fireRedirect: state.buildings.redirect
});

const mapDispatchtoProps = dispatch => ({
	buildingFetch: id => dispatch(getOne('buildings', {}, id)),
	editBuilding: (data, id) => dispatch(edit('buildings', data, id)),
});

export default connect(mapStateToProps, mapDispatchtoProps)(BuildingEditPage);



// WEBPACK FOOTER //
// ./src/Pages/Buildings/BuildingsEdit/BuildingsEdit.js